import { v4 as uuid } from "uuid";

import {
  Action,
  ActionBase,
  ActionType,
  BallAction,
  BasketballActionType,
  HandoffAction,
  HockeyActionType,
  PlayerAction,
  PossessionAction,
  StencilType,
} from "../types";
import { SoccerActionLineType } from "../types/frame-stencil/soccer";

export interface CreateNewActionProps {
  layerType: Action["layerType"];
  pos: Action["pos"];
  midPoints: Action["midPoints"];
  endPos: Action["endPos"];
}

export const createNewAction = ({ pos, midPoints, endPos, layerType }: CreateNewActionProps): Action => {
  const baseAction: ActionBase = {
    id: uuid(),
    stencilType: StencilType.ACTION,
    pos,
    midPoints,
    endPos,
    startTime: 0,
    endTime: 1000,
  };

  return ((): Action => {
    switch (layerType) {
      case BasketballActionType.CUT:
      case BasketballActionType.SCREEN:
      case HockeyActionType.SKATE:
      case HockeyActionType.SKATE_BACKWARDS:
      case HockeyActionType.SKATE_LATERAL:
      case SoccerActionLineType.SC_RUN:
      case SoccerActionLineType.SC_RUN_AND_STOP: {
        const playerAction: PlayerAction = {
          ...baseAction,
          actionType: ActionType.PLAYER,
          layerType,
          nextPlayerAction: null,
        };
        return playerAction;
      }

      case BasketballActionType.HASHPASS: {
        const ballAction: BallAction = {
          ...baseAction,
          actionType: ActionType.BALL,
          layerType,
          nextBallAction: null,
          nextPlayer: null,
          prevPlayer: null,
          playerActionStart: null,
          playerActionEnd: null,
          numberOfHashes: 1,
        };
        return ballAction;
      }
      case BasketballActionType.PASS:
      case HockeyActionType.PASS:
      case HockeyActionType.SHOOT:
      case SoccerActionLineType.SC_PASS:
      case SoccerActionLineType.SC_SHOT: {
        const ballAction: BallAction = {
          ...baseAction,
          actionType: ActionType.BALL,
          layerType,
          nextBallAction: null,
          nextPlayer: null,
          prevPlayer: null,
          playerActionStart: null,
          playerActionEnd: null,
        };
        return ballAction;
      }

      case BasketballActionType.HANDOFF:
      case HockeyActionType.HANDOFF:
      case SoccerActionLineType.SC_HANDOFF: {
        const handoffAction: HandoffAction = {
          ...baseAction,
          actionType: ActionType.HANDOFF,
          layerType,
          startPos: baseAction.pos,
          prevPlayer: null,
          nextPlayer: null,
          prevAction: null,
          nextAction: null,
        };
        return handoffAction;
      }

      case BasketballActionType.DRIBBLE:
      case BasketballActionType.CUT_RECEIVING_HANDOFF:
      case BasketballActionType.SCREEN_RECEIVING_HANDOFF:
      case HockeyActionType.SKATE_RECEIVING_HANDOFF:
      case HockeyActionType.SKATE_BACKWARDS_RECEIVING_HANDOFF:
      case HockeyActionType.SKATE_LATERAL_RECEIVING_HANDOFF:
      case HockeyActionType.SKATE_WITH_PUCK:
      case HockeyActionType.SKATE_BACKWARDS_WITH_PUCK:
      case SoccerActionLineType.SC_DRIBBLE:
      case SoccerActionLineType.SC_DRIBBLE_AND_STOP:
      case SoccerActionLineType.SC_RUN_RECEIVING_HANDOFF:
      case SoccerActionLineType.SC_RUN_AND_STOP_RECEIVING_HANDOFF: {
        const possessionAction: PossessionAction = {
          ...baseAction,
          actionType: ActionType.POSSESSION,
          layerType,
          nextPlayerAction: null,
          nextBallAction: null,
        };
        return possessionAction;
      }
    }
  })();
};
